import type { IUserInfo } from '@/types/home'
import { defineStore } from 'pinia'
import { fetUserInfo } from '@/services/home'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  const userInfo = ref<IUserInfo | null>(null)
  const loading = ref(false)

  // 获取用户信息
  const getUserInfo: () => Promise<IUserInfo | null> = async (force = false) => {
    // 如果已有数据且不强制刷新，直接返回
    if (userInfo.value && !force) {
      return userInfo.value
    }

    // 如果正在加载中，等待加载完成
    if (loading.value) {
      return new Promise(resolve => {
        const checkLoading = () => {
          if (!loading.value) {
            resolve(userInfo.value)
          } else {
            setTimeout(checkLoading, 100)
          }
        }

        checkLoading()
      })
    }

    try {
      loading.value = true
      const res = await fetUserInfo()

      userInfo.value = res?.data?.result || null
      return userInfo.value
    } catch (error) {
      console.error('获取用户信息失败:', error)
      return null
    } finally {
      loading.value = false
    }
  }

  // 清除用户信息
  const clearUserInfo = () => {
    userInfo.value = null
  }

  // 更新用户信息
  const updateUserInfo = (newUserInfo: IUserInfo) => {
    userInfo.value = newUserInfo
  }

  return {
    userInfo,
    loading,
    getUserInfo,
    clearUserInfo,
    updateUserInfo
  }
})
